.issueLink {
	outline-offset: 0 !important;
}
